const fieldPrefix = 'parts';

function multiFormToJson(formData) {
    const json2 = formToJSON(formData);

    const parts = [];
    for (let i = 0; i < 10; i++) {
        const key = fieldPrefix + '[' + i + ']';

        if (json2[key + '.index'] !== undefined) {
            const subForm = {};
            _.mapObject(_.pick(json2, function(value, k, object) {
                return k.indexOf(key) >= 0;
            }), function(v, k) {
                subForm[k.substring(key.length + 1)] = v;
            });

            const custom = {};
            _.mapObject(_.pick(subForm, function(v, k) {
                return k.indexOf('custom[') >= 0;
            }), function(v, k) {
               custom[k.substring('custom['.length + 1, k.length - 2)] = v;
            });
            subForm.custom = custom;

            parts.push(subForm);
            delete json2[key]
        }
    }

    json2[fieldPrefix] = parts;

    return json2;
}

function switchSkillOptionsMulti() {
    const sport = $(this).val();
    if ((sport || '') === '') {
        return;
    }

    const opts = sportStatuses.get(sport);
    const skillField = $(this).closest('.part-section').find('[id$="skill"]');

    opts.forEach(function(v, k) {
        const option = skillField.find('option[value="' + k + '"]');
        if (option.length === 0) {
            skillField.append('<option value="' + k + '">' + v + '</option>');
        } else {
            option.text(v);
        }
    });

    if (M != undefined) {
        M.FormSelect.init(skillField);
    }
}

function onMultiCalcPriceChange(res, cb) {
    const parts = new Map(Object.entries(res.participations));
    parts.forEach(function(v, k) {
        const part = $('.sub-index[value="' + k + '"]').closest('.part-section');
        part.find('[name$="addonIds"][disabled]').removeAttr('checked');

        v.addonIds.forEach(function(id) {
            part.find('[name$="addonIds"][value="' + id + '"]').each(function() {
                $(this).attr('checked', 'checked');

            })
        });

        v.activeAddonIds.forEach(function (id) {
            part.find('[name$="addonIds"][value="' + id + '"]').each(function() {
                if ($(this).attr('data-auto') === 'true') {
                    $(this).prop('checked', true);
                }
                $(this).closest('div').show();
                $(this).closest('label').show();
            });
        });

        if (cb !== undefined) {
            cb(part);
        }
    });
}

$( document ).ready(function() {
    $(document).on('change', '[id$="sport"]', switchSkillOptionsMulti);
    $(document).on('change', '.addr-toggle', function() {
        $(this).closest('.part-section').find('.address-fields').toggle($(this).is(':checked'));
    });

    $('.with-field .custom-control-input').each(function() {
        const cont = $(this).closest('.sub-addon-cont');
        cont.find('.extra-field-row').toggle($(this).is(':checked'))
    });
    $(document).on('change', '.with-field .custom-control-input', function() {
        $(this).closest('.sub-addon-cont')
            .find('.extra-field-row').toggle($(this).is(':checked'));
    });
});

module.exports = {
    multiFormToJson: multiFormToJson,
    onMultiCalcPriceChange: onMultiCalcPriceChange,
    fieldPrefix: fieldPrefix
};